import type {
  ComponentPropsWithoutRef,
  FunctionComponent,
  ReactNode,
} from 'react'
import React from 'react'

import classnames from 'classnames'

import type { ImageSource } from '../../../types'
import type { ViewAllLink } from '../../LinkBlock/MultiLinkBlock'
import { MultiLinkBlock } from '../../LinkBlock/MultiLinkBlock'
import { Picture } from '../../Picture'
import styles from './MultiLinkCard.module.scss'

export const MultiLinkCard: FunctionComponent<Props> = ({
  display,
  title,
  titleLink = '',
  image,
  imageSources,
  imageAlt = '',
  className,
  links,
  viewAllLink,
  ...rest
}) => (
  <article
    data-testid="multi-link-card-wrapper"
    className={classnames(
      {
        [styles.multiLinkCard]: true,
        [styles.multiLinkCardScrollRow]: display === 'scroll-row',
      },
      className
    )}
    {...rest}
  >
    {image && (
      <Picture
        src={image}
        sources={imageSources}
        alt={imageAlt}
        aspectRatioMain="two-to-one"
      />
    )}
    <MultiLinkBlock
      className={styles.multiLinkCardText}
      componentType="multi-link-card"
      title={title}
      titleLink={titleLink}
      links={links}
      viewAllLink={viewAllLink}
      headerTag="h2"
    />
  </article>
)

///////// IMPLEMENTATION /////////

export type Props = {
  /**
   * Display format affects layout of the card
   */
  display?: string
  /**
   * Title that will appear within the article card.
   */
  title: string
  /**
   * TitleLink an optional href for the Title
   */
  titleLink?: string
  /**
   * Image link to be displayed at the top of the article card if provided.
   */

  image?: string
  /**
   * Array of sources for the Picture tag.
   */
  imageSources?: ImageSource[]
  /**
   * Text to be used in the Image alt tag.
   */
  imageAlt?: string
  /**
   * Class name that can be added to add extra styling to the component
   */
  className?: string
  /**
   * Links
   */
  links: LinkType[]
  /**
   * Optional link to be displayed at the bottom of card
   */
  viewAllLink?: ViewAllLink | null
} & ComponentPropsWithoutRef<'article'>

export type LinkType = {
  text: string
  href: string
  type?: 'bestBuy' | 'dontBuy' | 'standard'
  children: ReactNode
}
